import { render, staticRenderFns } from "./TabSlotWrapper.vue?vue&type=template&id=ed998f44&"
import script from "./TabSlotWrapper.vue?vue&type=script&lang=ts&"
export * from "./TabSlotWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports